import React from "react";
import { useSelector } from "react-redux";
import { authStatusSelector, errorSelector } from "../common/redux/selectors";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Layout } from "./presentation/Layout";
import { NotLoggedIn } from "./presentation/dialogs/NotLoggedIn";
import { LoggingIn } from "./presentation/dialogs/LoggingIn";
import { MissingRoute } from "./presentation/dialogs/MissingRoute";

export const Component: React.FC = (props) => {
  const authStatus = useSelector(authStatusSelector);
  const errorStatus = useSelector(errorSelector);
  console.log(errorStatus?.status);
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        path={[
          `${path}:commmunications/:resourceType/:resourceId`,
          `${path}:resourceType/:resourceId`,
          `${path}:resourceType/:resourceId/recognition/applications/:applicationId`, // for organisation recogniton
          `${path}:resourceType/:resourceId/recognition/applications/:applicationId/:area`, // for organisation recogniton
          `${path}:resourceType/:resourceId/scope/applications/:applicationId/:area`, // for organisation scope applications
          `${path}:resourceType/:resourceId/scope-recognition`, // for organisation tabs
          `${path}:resourceType/:resourceId/scope`, // for organisation tabs
          `${path}:resourceType/:resourceId/recognition`, // for organisation tabs
        ]}
        exact
      >
        {authStatus === "NOT_LOGGED_IN" && (
          <Layout>
            <NotLoggedIn />
          </Layout>
        )}
        {authStatus === "LOGGING_IN" && (
          <Layout>
            <LoggingIn />
          </Layout>
        )}
        {authStatus === "LOGGED_IN" && props.children}
      </Route>
      <Route>
        <Layout>
          <MissingRoute />
        </Layout>
      </Route>
    </Switch>
  );
};
